import * as ko from 'knockout';
import {Event} from "Core/Common/Event";
import {Modal} from "Core/Common/Modal";
import {LABELS, NOTIFICATIONS} from "Core/Components/Translation/Locales";

import NextPublicationModalTemplate from 'Core/NextPublication/Templates/NextPublicationModal.html';
ko.templates['Core/NextPublication/Templates/NextPublicationModal'] = NextPublicationModalTemplate;

export class NextPublicationModal extends Event {
    private _modal: Modal;
    private _title: string;
    public _labels = LABELS;

    constructor() {
        super();
    }

    public Load(displayDate: string) {
        this._title = NOTIFICATIONS.NEXT_PUBLICATION_SCHEDULED.replace('{date}', displayDate);
        this.Show();
    }

    public Close() {
        if (this._modal) {
            this._modal.Close();
        }
    }

    private Show() {
        this._modal = new Modal({
            width: '450',
            addClass: 'next-publication-popup',
            height: '415',
            zIndex: 2147483600,
            animation: {
                open: 'tada',
                close: 'flip'
            }
        } as any, false);
        this._modal.One('CLOSE', this, () => this.Close());
        ko.cleanNode(this._modal.Wrapper);
        ko.applyBindings(this, this._modal.Wrapper);
        this._modal.Show();
    }

    GetTemplateName(): string {
        return 'Core/NextPublication/Templates/NextPublicationModal';
    }

    AfterRender(el: HTMLElement) {
    }

    private OkButtonClicked() {
        this.Close();
    }
}
